import { Component } from '@angular/core';

@Component({
  selector: 'pc-circle-group-3',
  standalone: true,
  imports: [],
  templateUrl: './circle-group-3.component.html',
  styleUrl: './circle-group-3.component.scss'
})
export class CircleGroup3Component {

}
